import { ChatModel as ChatApiClient } from '@/http/models/Chat/Chat'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { ChatHttpParams, ChatModel } from '@/types'

export interface ChatSessionFilters {
  customer_id?: string
}

export interface ChatSessionListForm extends UseFetchListForm<
  ChatSessionFilters,
  ChatModel.ChatSession
> {}

export const chatSessionInitialFilters: ChatSessionFilters = {
  customer_id: undefined,
}

export const useFetchChatSessions = () => {
  return useFetchList<
    ChatSessionFilters,
    ChatModel.ChatSession,
    {},
    ChatHttpParams.GetSessions['query'],
    typeof ChatApiClient.getSessions
  >({
    pageSize: 10,
    initialFilters: chatSessionInitialFilters,
    fetchFunction: ChatApiClient.getSessions,
    buildQueryParams: (filters): Partial<ChatHttpParams.GetSessions['query']> => ({
      customer_id: filters.customer_id || undefined,
    }),
    buildParams: () => ({}),
  })
}
